import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { Alert, Modal, Button, Table, Form } from 'react-bootstrap';
import { fetchGrades, createCategory, fetchSubjectCategoryCount, updateSubject } from '../../api/api';

const SubjectEdit = () => {
  const { id } = useParams();
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const [subjectName, setSubjectName] = useState('');
  const [formerSubjectName, setFormerSubjectName] = useState('');
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategoryYear, setNewCategoryYear] = useState('');
  const [grades, setGrades] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    const fetchSubjectCategories = async () => {
      try {
        const subject = await fetchSubjectCategoryCount(id);
        setSubjectName(subject.name);
        setFormerSubjectName(subject.name);

        const subjectMap = subject.categories.map(category => {
          return {
            name: category.name,
            year: category.grade_name,
            activity_count: category.activity_count,
          };
        });

        setCategories(subjectMap);
      } catch (error) {
        console.error("Error fetching subject:", error);
      }
    }
    fetchSubjectCategories();

    const fetchGradesForSubject = async () => {
      try {
        const fetchedGrades = await fetchGrades();
        setGrades(fetchedGrades || []);
      } catch (error) {
        console.error("Error fetching grades:", error);
      }
    };
    fetchGradesForSubject();
  }, [id]);

  const handleAddCategory = async () => {
    const grade = grades.find(({ uuid }) => uuid === newCategoryYear);
    if (newCategoryName && grade) {
      try {
        await createCategory(newCategoryName, id, grade.uuid);
        setCategories([...categories, { name: newCategoryName, year: grade.name, activity_count: 0 }]);
        setShowModal(false);
        setNewCategoryName('');
        setNewCategoryYear('');
      } catch (error) {
        // console.log(error);
      }
    }
  };

  const handleSubjectNameChangeButtonAction = async (newValue) => {
    setSubjectName(newValue);
    if (newValue !== formerSubjectName) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  };

  const handleSubjectNameChange = async () => {
    try {
      await updateSubject(id, subjectName);
      setFormerSubjectName(subjectName);
      setShowSuccessAlert(true);
    } catch (error) {
      setShowErrorAlert(true);
      setSubjectName(formerSubjectName);
      console.error(error);
    }

    setTimeout(() => {
      setShowSuccessAlert(false);
      setShowErrorAlert(false);
    }, 3000);

    setIsButtonDisabled(true);

  };

  return (
    <DashboardLayout title="Editar Matéria">
      <ReducedContent>
        {showSuccessAlert && (
          <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
            Matéria atualizada com sucesso!
          </Alert>
        )}

        {showErrorAlert && (
          <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
            Erro ao alterar matéria. Tente novamente.
          </Alert>
        )}
        <div className="input-group mb-3">
          <span className="input-group-text">Nome</span>
          <input
            className="form-control"
            value={subjectName}
            onChange={(e) => handleSubjectNameChangeButtonAction(e.target.value)}
            required
          />
          <div className="invalid-feedback">
            Forneça um nome.
          </div>
          <button
            disabled={isButtonDisabled}
            className="btn btn-primary"
            type="submit"
            onClick={() => handleSubjectNameChange()}
          >
            Salvar
          </button>
        </div>

        <h4>Categorias</h4>
        <Button class="btn btn-link" onClick={() => setShowModal(true)}>Adicionar Categoria</Button>
        <Table bordered className="mt-3">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Ano</th>
              <th># Atividades</th>
            </tr>
          </thead>
          <tbody>
            {categories.length ? categories.map(({ name, year, activity_count }, idx) => (
              <tr key={idx}>
                <td>{name}</td>
                <td>{year}</td>
                <td>{activity_count}</td>
              </tr>
            )) : (
              <tr><td colSpan="3" className="text-center">Nenhuma categoria adicionada</td></tr>
            )}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Adicionar Nova Categoria</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nome da Categoria</Form.Label>
              <Form.Control
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Ano</Form.Label>
              <Form.Select
                value={newCategoryYear}
                onChange={(e) => setNewCategoryYear(e.target.value)}
                required
              >
                <option value="" disabled>Escolha...</option>
                {grades.map(({ uuid, name }) => (
                  <option key={uuid} value={uuid}>{name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
            <Button variant="primary" onClick={handleAddCategory}>Adicionar</Button>
          </Modal.Footer>
        </Modal>
      </ReducedContent>
    </DashboardLayout>
  );
};

export default SubjectEdit;
